import { useMutation, useQueryClient } from 'react-query';
import { communicationKeys } from '../cache-keys/communicationKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { comment_api } from '@axo/shared/data-access/api';

export function useDeleteComment(applicationID: string) {
  const api = useAPI();
  const client = useQueryClient();

  return useMutation(comment_api.deleteComment(api), {
    onSuccess: () =>
      client.invalidateQueries(communicationKeys.comments({ applicationID })),
  });
}
